__turbopack_context__.v({
  "className": "montserrat_ed86eb30-module__S6Av_W__className",
});
